export enum HHDSVideoEvent {
	componentConnected = 'component-connected',
	loaded = 'video-loaded',
	coverLoaded = 'cover-loaded',
	bufferStart = 'bufferStart',
	play = 'play',
	playRequest = 'playRequest',
	pause = 'pause',
	ended = 'ended',
	loop = 'loop',
	timeUpdate = 'timeUpdate',
}

export enum HHDSVideoFitDimension {
	width = 'width',
	height = 'height',
	auto = 'auto',
	none = 'none',
}
